/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";

import DataTable, { Column } from "components/DataTable";
import { useTranslation } from "contexts/i18nContext";
import { fetchComplaintLogs } from "services/prosecutorDecipilineService";
import { DateView } from "utils/helper";
import "../complaintRequest/complaintRequest.css";

const ListProsecutorLogs: React.FC = () => {
  // const [activeTab, setActiveTab] = useState<string>("All");
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");
  const [logsData, setLogsData] = useState<any[]>([]);

  useEffect(() => {
    // setLoading(true);
    const loadLogs = async () => {
      try {
        const data = await fetchComplaintLogs();
        setLogsData(data);
        // setError("");
      } catch (err) {
        // setError("Failed to load logs.");
      } finally {
        // setLoading(false);
      }
    };
    loadLogs();
  }, []);

  const { t } = useTranslation();
  const columns: Column<any>[] = [
    {
      header: t("changedBy"),
      accessor: "changed_by",
      render: (row) => (
        <div className="flex items-center gap-3">
          <img
            src={require("../../images/avatar.png")}
            className="w-10 h-10 rounded-full grayscale"
          />
          <span>{row.changed_by}</span>
        </div>
      ),
      widthClass: "w-1/5",
    },
    {
      header: t("modelName"),
      accessor: "model_name",
      render: (row) => row.model_name ?? "—",
    },
    {
      header: t("actionType"),
      accessor: "action_type",
      render: (row) => row.action_type ?? "—",
    },
    {
      header: t("fieldName"),
      accessor: "field_name",
      render: (row) => row.field_name ?? "—",
    },
    // {
    //   header: t("oldValue"),
    //   accessor: "old_value",
    //   render: (row) => row.old_value ?? "—",
    // },
    // {
    //   header: t("newValue"),
    //   accessor: "new_value",
    //   render: (row) => row.new_value ?? "—",
    // },
    {
      header: t("additionalInfo"),
      accessor: "additional_info",
      render: (row) => row.additional_info ?? "—",
    },
    {
      header: t("date"),
      accessor: "changed_at",
      render: (row) => DateView(row.changed_at),
    },
  ];

  return (
    <div className=" mx-auto flex flex-col space-y-4">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>⚖</span>
        {t("activityLogs")}
      </h1>

      {/* Header: Tabs + Add button */}
      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <DataTable
          title={t("tableTitle")}
          columns={columns}
          data={logsData || []}
          rowKey={(row) => row.uu_id}
          onSearch={(q) => {}}
        />
      </div>
    </div>
  );
};

export default ListProsecutorLogs;
